export const TOGGLE_LOADING = 'opv/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'opv/TOGGLE_SUCCESS'
export const OPV_LIST = 'opv/OPV_LIST'
export const SELECTED_OPV = 'opv/SELECTED_OPV'
